import { AllContentRoleIds } from "@/constants/userRoles";
import { RouteRecordRaw } from "vue-router";

export default [
  {
    path: "/content/tag-new-questions/:pdfUUID?",
    component: () =>
      import(
        /* webpackChunkName: 'TagNewQuestions' */ "@/views/content/questionBank/TagNewQuestions.vue"
      ),
    name: "TagNewQuestions",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllContentRoleIds,
    },
  },
  {
    path: "/content/review-tagged-questions/:pdfUUID?",
    component: () =>
      import(
        /* webpackChunkName: 'ReviewTaggedQuestions' */ "@/views/content/questionBank/ReviewTaggedQuestions.vue"
      ),
    name: "ReviewTaggedQuestions",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllContentRoleIds,
    },
  },
  {
    path: "/content/fix-chapter-questions",
    component: () =>
      import(
        /* webpackChunkName: 'FixChapterQuestions' */ "@/views/content/questionBank/FixChapterQuestions.vue"
      ),
    name: "FixChapterQuestions",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllContentRoleIds,
    },
  },
  {
    path: "/content/manage-question-pdfs",
    component: () =>
      import(
        /* webpackChunkName: 'ManageQuestionPdfs' */ "@/views/content/questionBank/ManageQuestionPdfs.vue"
      ),
    name: "ManageQuestionPdfs",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllContentRoleIds,
    },
  },
  {
    path: "/content/fix-question",
    component: () =>
      import(/* webpackChunkName: 'FixQuestionSection' */ "@/views/content/FixQuestionSection.vue"),
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllContentRoleIds,
    },
    children: [
      {
        // Static segment — outranks the sibling :questionId? param in route resolution.
        path: "search",
        name: "FixQuestionSearch",
        component: () =>
          import(
            /* webpackChunkName: 'FixQuestionSearch' */ "@/views/content/FixQuestionSearch.vue"
          ),
        meta: {
          requiresAuth: true,
          scrollToTop: true,
          allowedRoleIds: AllContentRoleIds,
        },
      },
      {
        path: ":questionId?",
        name: "FixQuestion",
        component: () =>
          import(/* webpackChunkName: 'FixQuestion' */ "@/views/content/FixQuestion.vue"),
        meta: {
          requiresAuth: true,
          scrollToTop: true,
          allowedRoleIds: AllContentRoleIds,
        },
      },
    ],
  },
  {
    path: "/content/review-course-content",
    component: () =>
      import(
        /* webpackChunkName: 'ReviewCourseContent' */ "@/views/content/ReviewCourseContent.vue"
      ),
    name: "ReviewCourseContent",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllContentRoleIds,
    },
  },
  {
    path: "/content/chapter-workbench",
    component: () =>
      import(/* webpackChunkName: 'ChapterWorkbench' */ "@/views/content/ChapterWorkbench.vue"),
    name: "ChapterWorkbench",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllContentRoleIds,
    },
  },
  {
    path: "/content/ai-messenger",
    component: () =>
      import(/* webpackChunkName: 'AiMessenger' */ "@/views/content/AiMessenger.vue"),
    name: "AiMessenger",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllContentRoleIds,
    },
  },
  {
    path: "/content/content-mapping/:courseId?",
    component: () =>
      import(/* webpackChunkName: 'ContentMapping' */ "@/views/content/ContentMapping.vue"),
    name: "ContentMapping",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllContentRoleIds,
    },
  },
  {
    path: "/content/manage-qr-codes",
    component: () =>
      import(/* webpackChunkName: 'ManageQrCodes' */ "@/views/content/ManageQrCodes.vue"),
    name: "ManageQrCodes",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllContentRoleIds,
    },
  },
  {
    path: "/content/create-qr-code",
    component: () =>
      import(/* webpackChunkName: 'CreateQrCode' */ "@/views/content/CreateQrCode.vue"),
    name: "CreateQrCode",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllContentRoleIds,
    },
  },
  {
    path: "/content/manage-predesigned-activities",
    component: () =>
      import(
        /* webpackChunkName: 'ManagePredesignedActivities' */ "@/views/content/ManagePredesignedActivities.vue"
      ),
    name: "ManagePredesignedActivities",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllContentRoleIds,
    },
  },
  {
    path: "/content/manage-predesigned-activities/questions",
    component: () =>
      import(
        /* webpackChunkName: 'ManagePredesignedActivityQuestions' */ "@/views/content/ManagePredesignedActivityQuestions.vue"
      ),
    name: "ManagePredesignedActivityQuestions",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllContentRoleIds,
    },
  },
  {
    path: "/content/chapter-questions-review",
    component: () =>
      import(
        /* webpackChunkName: 'ChapterQuestionsReview' */ "@/views/content/ChapterQuestionsReview.vue"
      ),
    name: "ChapterQuestionsReview",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllContentRoleIds,
    },
  },
  {
    path: "/content/course-wise-question-counts",
    component: () =>
      import(
        /* webpackChunkName: 'CourseWiseQuestionCounts' */ "@/views/content/CourseWiseQuestionCounts.vue"
      ),
    name: "CourseWiseQuestionCounts",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllContentRoleIds,
    },
  },
  {
    path: "/content/similar-questions-review",
    component: () =>
      import(
        /* webpackChunkName: 'SimilarQuestionsReview' */ "@/views/content/SimilarQuestionsReview.vue"
      ),
    name: "SimilarQuestionsReview",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllContentRoleIds,
    },
  },
  {
    path: "/content/manage-smart-books",
    component: () =>
      import(
        /* webpackChunkName: 'ManageSmartBooks' */ "@/views/content/smartBook/ManageSmartBooks.vue"
      ),
    name: "ManageSmartBooks",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllContentRoleIds,
    },
  },
  {
    path: "/content/smart-book-chapter-review/:smartBookId?/:subjectChapterId?",
    component: () =>
      import(
        /* webpackChunkName: 'SmartBookChapterReview' */ "@/views/content/smartBook/SmartBookChapterReview.vue"
      ),
    name: "SmartBookChapterReview",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllContentRoleIds,
    },
  },
  {
    path: "/content/manage-learn-videos",
    component: () =>
      import(/* webpackChunkName: 'ManageLearnVideos' */ "@/views/content/ManageLearnVideos.vue"),
    name: "ManageLearnVideos",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllContentRoleIds,
    },
  },
  {
    path: "/content/qr-theme-preview",
    component: () =>
      import(/* webpackChunkName: 'QrThemePreview' */ "@/views/content/QrThemePreview.vue"),
    name: "QrThemePreview",
    meta: {
      requiresAuth: true,
      allowedRoleIds: AllContentRoleIds,
      scrollToTop: true,
      excludeNavbar: false,
      showAppFooter: false,
      hideFooterNavigator: true,
      overrideBackButton: false,
    },
  },
  {
    path: "/content/video-library",
    component: () =>
      import(
        /* webpackChunkName: 'ContentVideoLibrary' */ "@/views/content/ContentVideoLibrary.vue"
      ),
    name: "ContentVideoLibrary",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllContentRoleIds,
    },
  },
  {
    path: "/content/lecture-library",
    component: () =>
      import(
        /* webpackChunkName: 'ContentLectureLibrary' */ "@/views/content/ContentLectureLibrary.vue"
      ),
    name: "ContentLectureLibrary",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllContentRoleIds,
    },
  },
  {
    path: "/content/teaching-aid-library",
    component: () =>
      import(
        /* webpackChunkName: 'ContentTeachingAidLibrary' */ "@/views/content/ContentTeachingAidLibrary.vue"
      ),
    name: "ContentTeachingAidLibrary",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllContentRoleIds,
    },
  },
  {
    path: "/content/design-library",
    component: () =>
      import(
        /* webpackChunkName: 'ContentDesignLibrary' */ "@/views/content/ContentDesignLibrary.vue"
      ),
    name: "ContentDesignLibrary",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllContentRoleIds,
    },
  },
  {
    path: "/content/course-library",
    component: () =>
      import(
        /* webpackChunkName: 'ContentCourseLibrary' */ "@/views/content/ContentCourseLibrary.vue"
      ),
    name: "ContentCourseLibrary",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllContentRoleIds,
    },
  },
  {
    path: "/content/question-coverage",
    component: () =>
      import(
        /* webpackChunkName: 'ContentQuestionCoverage' */ "@/views/content/ContentQuestionCoverage.vue"
      ),
    name: "ContentQuestionCoverage",
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      allowedRoleIds: AllContentRoleIds,
    },
  },
] as unknown as Array<RouteRecordRaw>;
